/* eslint-disable no-restricted-syntax */
/* eslint-disable react/no-access-state-in-setstate */
import React, { Component } from 'react';
import { Translate, I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';
import Dropzone from 'react-dropzone';
import MultiSelect from '../../multi-select/MultiSelect';
import {
  solicitationUserClient,
  solicitationApproveUser,
  downloadImage,
  uploadImages,
  updateStatusSolicitations,
} from '../../../app/store/actions/solicitations';
import {
  updateUsersPermission,
  createUser,
  getUsers,
  getParamsNewUser,
} from '../../../app/store/actions/users';
import { history } from '../../../routers/AppRouter';
import { getContracts } from '../../../app/store/actions/contracts';
import { searchSphereContacts } from '../../../app/store/actions/contacts';
import ClientsAction from '../../../app/store/actions/clients';
import {
  validateCheckboxPermissions,
  setInitialCheckboxsStatesAndValues,
  setCheckboxLabels,
} from './helpers/permissionRules';
import ROUTES from '../../../data/routes';
import {
  permissionsInit,
  initialState,
  defaultState,
  config,
} from './data/permissions';
import { validator } from './helpers/validator';
import { getUpdateData } from './helpers/update';

import ButtonsUser from './components/buttons';
import HasUser from './components/hasUser';
import setUserClient from './helpers/create';
import { AutoComplete } from './components/autoComplete';
import Checkbox from './components/checkbox';
import NumberHelper from '../../../helpers/numbers';
import FIELDS from '../../../data/fields';
import ApproveInput from './components/approveInput';
import SelectComponent from '../../select/Select';
import ModalComponent from '../../modal';
import Notification from '../../notifications';
import randomPassword from '../../../helpers/generator';

let clientHelper = '';

class UsersFormComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      permissions: permissionsInit,
      inputsStateDisabled: [],
      inputsLabel: [],
      ...initialState,
      checked: [],
      selectLimits: [],
      isEmailSelected: false,
      clientId:
        props.back.location.client && props.back.location.client.clientId,
      limit: 20,
      page: 1,
      search: '',
      type: '',
      status: '',
      orderBy: 'ASC',
      field: 'userId',
      locationId: '',
      bu: '',
      deposit: '',
      listClient: '',
      clientWithdraw: '',
      checkedDeliveryLocations: [],
      listDeliveryLocations: [],
      firstName: '',
      showModal: false,
      imageShowModal: '',
      nameImage: '',
      buDisabled: false,
      depositDisabled: false,
      locationIdDisabled: false,
      showError: false,
      errorMessage: '',
      nickname: '',
      emails: '',
      loadImage: false,
      imageClicked: '',
      files: [],
      personalDocument: '',
      documentCompany: '',
      allowMixedPurchase: false,
    };

    config.forEach((items) => {
      items.permissions.forEach((item) => {
        this.state.permissions[item.id] = false;
        this.state.inputsStateDisabled[item.id] = false;
        this.state.inputsLabel[item.id] = '';
      });
    });

    this.state.selectLimits = this.props.back.location.client && this.props.back.location.client.limits
      ? this.props.back.location.client.limits
      : [];
    const hasNoLimitOption = this.state.selectLimits.find(
      item => item.limit === -1,
    );
    if (!hasNoLimitOption) {
      this.state.selectLimits.push({ limit: -1 });
    }
  }

  async componentDidMount() {
    await this.setInitialConfig();
    await this.props.getClientSettings(this.state.nameAbbr);
    await this.initCheckbox();
    const inputsLabel = await setCheckboxLabels(this.state.inputsLabel);
    await this.setState({ inputsLabel });
    await this.getValuesDelivery();
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (this.props.clients) {
      if (
        !prevState.listClient
        || prevState.listClient !== this.state.listClient
      ) {
        this.renameClientDepositKeyForComponent(this.props.clients.stock[0]);
      }
    }
  };

  searchUsers = async () => {
    const {
      clientId,
      search,
      page,
      limit,
      type,
      status,
      orderBy = '',
      field = '',
    } = this.state;
    const skip = (page - 1) * limit;
    await this.props.searchItems(
      limit,
      skip,
      clientId,
      search,
      type,
      status,
      orderBy,
      field,
    );
  };

  defaultState = async (paramsNewUser) => {
    const {
      cartPermission,
      locationId,
      bu,
      deposit,
      clientWithdraw,
      cartUsersPermission,
      purchaseCreditPermission,
      purchaseDebitPermission,
      purchaseBankSlipPermission,
      purchaseBillingPermission,
      purchaseEstimatePermission,
      similarityPermission,
      stockPermission,
      leadTimePermission,
      crossSellingPermission,
      pricePermission,
      clientCodePermission,
      spotPermission,
      opicCodePermission,
      soneparCodePermission,
      visualizeAllOrdersPermission,
      purchasePaymentGateway,
      emailSeller,
      deliveryCode,
      allowMixedPurchase,
    } = paramsNewUser;

    await this.setState({
      ...defaultState,
      permissions: {
        ...defaultState.permissions,
        cart: cartPermission,
        price: pricePermission,
        purchaseCredit: purchaseCreditPermission,
        purchaseDebit: purchaseDebitPermission,
        purchaseBankSlip: purchaseBankSlipPermission,
        purchaseBilling: purchaseBillingPermission,
        purchaseEstimate: purchaseEstimatePermission,
        cartUsers: cartUsersPermission,
        similarity: similarityPermission,
        stock: stockPermission,
        leadTime: leadTimePermission,
        crossSelling: crossSellingPermission,
        clientCode: clientCodePermission,
        spot: spotPermission,
        opicCode: opicCodePermission,
        soneparCode: soneparCodePermission,
        purchasePaymentGateway,
        visualizeAllOrders: visualizeAllOrdersPermission,
        panel: visualizeAllOrdersPermission,
        allowMixedPurchase: allowMixedPurchase || false,
      },
      bu,
      deposit,
      locationId,
      clientWithdraw,
      checkedDepos: deposit && deposit.split(','),
      emailSeller,
      checkedDeliveryLocations: deliveryCode ? deliveryCode.split(',') : [],
    });
  };

  notification = (classe, message) => {
    this.setState({ showError: false, errorMessage: message, classe });
    setTimeout(() => {
      this.setState({ showError: false });
    }, 10000);
  };

  setInitialConfig = async () => {
    await this.searchUsers();

    if (this.props.back.location.state) {
      const { clientId } = this.props.back.location.client;
      const { nickname, emails } = this.props.back.location.state.client.clientData;
      const { serviceBranch, client, user } = this.props.back.location.state;
      const { nameAbbr } = client;
      await this.props.getContracts(client.clientData.clientId);

      const stateReplaced = serviceBranch
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^\w\s]/gi, '');

      try {
        const paramsNewUser = await this.props.getParamsNewUser(
          clientId,
          stateReplaced,
        );
        await this.defaultState(paramsNewUser);
      } catch (err) {
        if (err.response && err.response.data.error.code === 1618) {
          this.setState({ showError: true, errorMessage: I18n.t('deliveryLocationError') });
          setTimeout(() => {
            this.goBack();
          }, 10000);
        } else {
          this.setState({
            showError: true,
            errorMessage: I18n.t('errorOcurred'),
          });
          setTimeout(() => {
            this.goBack();
          }, 10000);
        }
      }

      const {
        email,
        firstName,
        lastName,
        hasUser = false,
        id,
      } = this.props.back.location.state;

      await this.setState({
        isEmailSelected: true,
        email,
        nameAbbr,
        firstName,
        lastName,
        hasUser,
        contactId: client.contacts[0].id,
        userId: user && user.id ? user.id : id,
        locationIdDisabled: true,
        buDisabled: true,
        depositDisabled: true,
        nickname,
        emails,
        solicitation: true,
        idSolicitation: id,
      });
    } else {
      const { client, item } = this.props.back.location;
      if (item) {
        await this.setState(getUpdateData(client, item));
        await this.setUserContracts(client.sphereClient.id);

        const { rows } = this.props.users;
        const {
          approveId1,
          approveId2,
          deposit,
          locationId,
          bu,
          deliveryCode,
          clientWithdraw,
          personalDocument,
          documentCompany,
        } = item;

        const approvedUserArray1 = rows
          .filter(user => user.userId === approveId1)
          .map(user => user.user.email);
        const approvedUserArray2 = rows
          .filter(user => user.userId === approveId2)
          .map(user => user.user.email);
        const deliveryLocations = deliveryCode
          ? deliveryCode.split(',')
          : [deliveryCode];
        const checkedDeliveryLocations = [];

        for (const element of deliveryLocations) {
          if (element) checkedDeliveryLocations.push(element);
        }

        await this.setState({
          approveEmail1: approvedUserArray1[0],
          approveEmail2: approvedUserArray2[0],
          deposit,
          checkedDepos: deposit && deposit.split(','),
          locationId,
          bu,
          checkedDeliveryLocations,
          clientWithdraw,
          nameAbbr: client.sphereClient.nameAbbr,
          personalDocument,
          documentCompany,
        });
      } else {
        await this.props.getContracts(client.sphereClient.id);
        await this.renameDepositKeyForComponent();
        const { clientId } = client;

        const paramsNewUser = await this.props.getParamsNewUser(clientId);

        await this.setState({
          hasUser: true,
          clientId: client.sphereClient.id,
          nameAbbr: client.sphereClient.nameAbbr,
          permissions: permissionsInit,
          checked: [],
          contracts: [],
        });

        await this.defaultState(paramsNewUser);
      }
    }
  };

  setUserLimit = (value) => {
    this.setState({ limit: Number(value) });
  };

  initCheckbox = async () => {
    const { inputsStateDisabled, permissions } = await setInitialCheckboxsStatesAndValues(
      this.state.permissions,
      this.state.inputsStateDisabled,
    );
    this.setState({ inputsStateDisabled, permissions });
  };

  setUserContracts = async (clientId) => {
    await this.props.getContracts(clientId);
    await this.renameDepositKeyForComponent();
  };

  renameDepositKeyForComponent = async () => {
    const { contracts = [] } = this.props;
    contracts.forEach((x) => {
      x.value = `${x.id}`;
      x.name = `${x.id} - ${x.name || I18n.t('contractNumberNotSetted')}, ${
        x.locationId
      }`;
    });
    await this.setState({ listContracts: contracts });
  };

  goBack = () => {
    const { screenBack } = this.props.back.location;

    if (screenBack && screenBack === 'solicitations') {
      history.push({ pathname: ROUTES.REGISTER_SOLICITATION });
    } else {
      history.push({
        pathname: ROUTES.USERS,
        item: this.props.back.location.client,
      });
    }
  };

  onCheckBox = async (e, id) => {
    const { permissions, inputsStateDisabled } = validateCheckboxPermissions(
      e,
      id,
      this.state.permissions,
      this.state.inputsStateDisabled,
    );
    await this.setState({ permissions, inputsStateDisabled });

    if (inputsStateDisabled.firstApproved) this.resetApproveEmail1();
    if (inputsStateDisabled.secondApproved) this.resetApproveEmail2();
  };

  updateUser = async () => {
    const {
      clientId,
      userId,
      contracts,
      permissions,
      listContracts,
      limit,
      approveId1,
      approveId2,
      locationId,
      bu,
      deposit,
      checkedDeliveryLocations,
      clientWithdraw,
      emailSeller,
    } = this.state;

    if (approveId2 && !approveId1) {
      return this.setState({ message: I18n.t('approveError1') });
    }

    permissions.contracts = contracts.filter(item => listContracts.find(
      contractItem => contractItem.id === Number(item),
    ));

    permissions.limit = limit;
    permissions.panel = permissions.visualizeAllOrders;

    try {
      const deliveryCodes = checkedDeliveryLocations.length
        ? checkedDeliveryLocations.toString()
        : null;

      permissions.allowMixedPurchase = this.state.permissions.allowMixedPurchase;

      await this.props.updateUsers(
        clientId,
        userId,
        permissions,
        approveId1,
        approveId2,
        locationId,
        bu,
        deposit,
        deliveryCodes,
        clientWithdraw,
        emailSeller,
      );
      if (
        !!this.props.usersPermissionsDeleteApprovers
        && this.props.usersPermissionsDeleteApprovers
          === 'APPROVER_WITH_PENDING_CART'
      ) {
        this.setState({
          success: '',
          message: I18n.t('approverWithPendingCart'),
        });
      } else {
        this.setState({ success: I18n.t('successActualized'), message: '' });
      }
    } catch (error) {
      if (error.details === 'APPROVER_WITH_PENDING_CART') {
        this.setState({
          success: '',
          message: I18n.t('approverWithPendingCart'),
        });
      } else {
        this.setState({ success: '', message: I18n.t('errorOcurred') });
      }
    }
  };

  createUserForm = async (registerSolicitation = false) => {
    const {
      role,
      firstName,
      lastName,
      permissions,
      locationId,
      bu,
      deposit,
      checkedDeliveryLocations,
      clientWithdraw,
      emailSeller,
      errorMessage,
      nickname,
      emails,
    } = this.state;

    if (errorMessage) {
      return;
    }

    const contactId = !registerSolicitation
      ? this.state.contactId
      : this.props.back.location.state.contactId;
    const userId = !registerSolicitation
      ? this.state.userId
      : this.props.back.location.state.user
        && this.props.back.location.state.user.id
        ? this.props.back.location.state.user.id
        : false;
    const isEmailSelected = !registerSolicitation
      ? this.state.isEmailSelected
      : true;
    const status = !registerSolicitation ? this.state.status : 'active';
    const { contracts, approveId1, approveId2 } = this.state;
    const { clientId } = this.props.back.location.client;
    const {
      companyOrDependent, cnpj, phone, serviceBranch,
    } = this.props.back.location.state || {};
    const { documentCompany, personalDocument } = this.props.back.location.state || {};
    const { screenBack } = this.props.back.location;

    if (approveId2 && !approveId1) {
      return this.setState({ message: I18n.t('approveError1') });
    }

    const isValid = validator({
      contactId,
      userId,
      firstName,
      email: this.state.email,
      isEmailSelected,
    });

    const deliveryCodes = checkedDeliveryLocations.length
      ? checkedDeliveryLocations.toString()
      : null;

    const userClient = setUserClient(
      permissions,
      userId,
      clientId,
      contactId,
      approveId1,
      approveId2,
      locationId,
      bu,
      deposit,
      deliveryCodes,
      clientWithdraw,
    );

    if (isValid.success === 'valid') {
      try {
        await this.setState({ checked: [] });
        await this.props.createUser({
          hasUser: !!userId,
          user: {
            role,
            status,
            name: `${firstName} ${lastName}`,
            email: this.state.email,
            phone,
          },
          userClient,
          contracts,
          documentCompany,
          personalDocument,
          dataClient: {
            companyOrDependent,
            cnpj,
            nickname,
            serviceBranch,
            emails,
            emailSeller,
          },
        });
        await this.setState({
          success: I18n.t('userCreated'),
        });
        await this.setInitialConfig();
        try {
          if (screenBack && screenBack === 'solicitations') {
            await this.props.updateStatusSolicitations(
              this.props.back.location.state.id,
              2,
            );
            history.push({ pathname: ROUTES.REGISTER_SOLICITATION });
          } else {
            history.push({
              pathname: ROUTES.USERS,
              item: this.props.back.location.client,
            });
          }
        } catch (erro) {}
        await this.setState({ success: '', message: I18n.t('errorOcurred') });
      } catch (err) {
        if (err.response && err.response.data.error.code === 1621) {
          this.setState({ success: '', message: I18n.t('notAllowedRegisterGuestUser') });
        } else {
          await this.setState({ success: "", message: I18n.t("errorOcurred") });
        }
      }
    } else {
      await this.setState(isValid);
    }
  };

  setSelectedContactGlobal = (item) => {
    clientHelper = item;
    return item.email;
  };

  setSearchOnChange = (search) => {
    if (search) {
      this.props.searchSphereContacts({
        limit: 10,
        skip: 0,
        clientId: this.props.back.location.client.clientId,
        search,
      });
    }
    this.setState({
      emailSearch: search,
      message: '',
      success: '',
    });
  };

  setSelectedApprover = (approver, type) => {
    if (type === 'firstApproved') {
      this.setState({
        approveId1: approver.id,
        approveEmail1: approver.email,
      });
    } else {
      this.setState({
        approveId2: approver.id,
        approveEmail2: approver.email,
      });
    }
  };

  setSelectedSphereContact = (email) => {
    const {
      name, id, user, lastName,
    } = clientHelper;
    this.setState({
      emailSearch: '',
      email,
      firstName: name,
      lastName,
      contactId: id,
      userId: user ? user.id : false,
      message: '',
      success: '',
      isEmailSelected: true,
    });
  };

  onFocusEmail = () => {
    this.setState({
      extraClass: '',
    });
  };

  onBlurEmail = () => {
    if (!this.state.email) {
      this.setState({
        extraClass: 'form-input-error',
      });
    }
  };

  resetEmail = () => {
    this.setState({
      email: '',
      isEmailSelected: false,
      firstName: '',
      lastName: '',
    });
  };

  result = (e) => {
    this.setState({
      contracts: e,
      checked: e,
      message: '',
      success: '',
    });
  };

  resetApproveEmail1 = () => {
    this.setState({
      approveId1: '',
      approveEmail1: '',
    });
  };

  resetApproveEmail2 = () => {
    this.setState({
      approveId2: '',
      approveEmail2: '',
    });
  };

  getSelectComponent = (title, attr, value, body, tooltip, disabled) => (
    <SelectComponent
      title={title}
      value={value}
      body={body}
      onChange={e => this.selectedItem(attr, e)}
      tooltip={tooltip}
      disabled={disabled}
    />
  );

  getValuesLocation = values => values.map(val => (
    <option key={val.id + val.crmTag} value={val.id}>
      {val.crmTag ? val.crmTag : `${val.id} - ${val.city}`}
    </option>
  ));

  selectedItem = (attr, value) => {
    const form = this.state;
    form[attr] = value.target.value;
    this.setState({ form, message: '', success: '' });
  };

  selectedClientWithdraw = (attr, value) => {
    const form = this.state;
    form[attr] = value.target.value === -1 ? null : value.target.value;
    this.setState({ form, message: '', success: '' });
  };

  getValuesDelivery = async () => {
    const listDeliveryLocations = this.props.clients.deliveryLocations.map(
      elem => ({
        value: elem.deliveryCode,
        name: `${elem.deliveryCode} - ${elem.address} - ${elem.city}`,
      }),
    );
    await this.setState({
      listDeliveryLocations: [...(listDeliveryLocations || [])],
    });
  };

  getValues = values => values.map(val => (
    <option key={val.id + val.description} value={val.id}>
      {val.description}
    </option>
  ));

  renameClientDepositKeyForComponent = async (client) => {
    if (!this.state.listClient) {
      client.forEach((x) => {
        x.name = x.value.toUpperCase();
        x.value = x.name.toUpperCase();
      });

      await this.setState({ listClient: client });
    }
  };

  setDepos = async (params) => {
    this.state.deposit = params.toString();
    this.state.checkedDepos = this.state.deposit && this.state.deposit.split(',');
  };

  onSelectOptions = async (checked) => {
    await this.setState({
      checkedDeliveryLocations: [...checked],
    });
  };

  showImageModal = async (imageShowModal, nameImage) => {
    await this.setState({
      showModal: true,
      imageShowModal,
      imageClicked: nameImage,
    });
  };

  uploadedFile = async () => {
    const { storageUrlBase } = this.props.settings;
    const {
      clientId,
      userId,
      files,
      imageShowModal,
      imageClicked,
      solicitation,
      idSolicitation,
    } = this.state;

    const file = files[0];

    let nameImageChange = '';

    if (imageShowModal && imageShowModal !== 'images/default-image.jpg') {
      nameImageChange = imageShowModal
        && imageShowModal.replace(
          new RegExp(
            `.*${storageUrlBase
              .split('/')
              .slice(2, 3)[0]
              .replace('.', '\\.')}/images/imagesSolicitations/`,
          ),
          '',
        );
    }
    if (!file) {
      this.setState({ message: I18n.t('selectImage'), success: '' });
    } else {
      try {
        this.setState({ loadImage: true });
        const hash = randomPassword();
        const extension = file.name.split('.').pop();
        const opico = this.props.settings.name;
        const name = `${opico}${hash}.${extension}`;

        const img = await uploadImages(
          file,
          name,
          nameImageChange,
          clientId,
          userId,
          imageClicked,
          solicitation,
          idSolicitation,
        );

        await this.setState({
          files: [],
          [`${imageClicked}`]: img,
          imageShowModal: img,
          showModal: false,
        });

        return img;
      } catch (err) {
        this.setState({
          message: I18n.t('invalidImageFormat'),
          success: '',
        });
      } finally {
        this.setState({ loadImage: false });
      }
    }
  };

  render() {
    const {
      emailSearch,
      email,
      firstName,
      lastName,
      fullName,
      hasUser,
      success,
      listContracts = [],
      checked,
      message,
      newClient,
      userId,
      permissions,
      inputsStateDisabled,
      inputsLabel,
      selectLimits,
      extraClass,
      checkedDeliveryLocations,
      listDeliveryLocations,
      approveId1,
      approveId2,
      approveEmail1,
      approveEmail2,
      locationId,
      bu,
      listClient,
      checkedDepos,
      clientWithdraw,
      clientId,
      showModal,
      imageShowModal,
      nameImage,
      buDisabled,
      depositDisabled,
      locationIdDisabled,
      showError,
      errorMessage,
      emailSeller,
      imageClicked,
      files,
    } = this.state;

    const { searched } = this.props;
    const clientData = this.props.back.location.client;
    const location = this.props.back.location;
    const { personalDocument, documentCompany } = location.state || this.state;

    const imageShowUserModal = files && files.length > 0 ? URL.createObjectURL(files[0]) : imageShowModal;

    return (
      <div className="form-main">
        <ModalComponent
          body={(
            <div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  marginRight: '5%',
                }}
              >
                <button
                  style={{ cursor: 'pointer' }}
                  onClick={() => this.setState({ showModal: false })}
                >
                  <i className="fas fa-window-close" />
                </button>
              </div>
              <img
                src={imageShowUserModal}
                alt="Image"
                height="600px"
                className="object-fit-fill img-fluid"
                style={{ maxWidth: '650px', border: '1px solid #000' }}
              />
              <div style={{ marginTop: '10px' }}>
                <Dropzone
                  onDrop={acceptedFiles => this.setState({ files: acceptedFiles })
                  }
                >
                  {({ getRootProps, getInputProps }) => (
                    <div
                      {...getRootProps()}
                      className="btn btn-dark"
                      style={{ alignItems: 'center' }}
                    >
                      <input {...getInputProps()} />
                      <p style={{ margin: 'auto' }}>
                        {I18n.t('selectNewImage')}
                      </p>
                    </div>
                  )}
                </Dropzone>
              </div>
              <div
                style={{
                  marginTop: '5px',
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                {files && files.length > 0 && (
                  <button
                    type="button"
                    onClick={() => this.uploadedFile()}
                    className="btn btn-warning"
                  >
                    <Translate value="confirmChangeImage" />
                  </button>
                )}
              </div>
            </div>
          )}
          visible={showModal}
          titleOkButtoon={I18n.t('downloadImage')}
          size={{ width: '900px', height: '900px' }}
          closeModal={() => this.setState({ showModal: false, files: [] })}
          confirmModal={() => this.props.downImage(imageShowModal)}
          showButtons
          showCancel
          titleCancelButton={I18n.t('close')}
        />
        <h2 className="header-form-client">
          {this.props.back.location.state
            ? I18n.t('userRegister')
            : I18n.t('userForm')}
        </h2>
        {clientData && (
          <div className="container-client-data">
            <span className="client-data-table">
              {clientData.clientId}
              {' - '}
              {clientData.sphereClient.name}
              {' - '}
              {clientData.nickname}
            </span>
          </div>
        )}
        <form>
          <p className="margin-bottom-2">
            <Translate value="email" />
            {' '}
            {email && newClient && (
              <span
                className="change-input-link"
                role="button"
                tabIndex={0}
                onKeyDown={this.resetEmail}
                onClick={this.resetEmail}
              >
                (
                <Translate value="change" />
                )
              </span>
            )}
          </p>
          {email ? (
            <div className="form-group">
              <input
                type="text"
                className="form-control"
                disabled
                value={email}
              />
            </div>
          ) : (
            <AutoComplete
              searched={searched}
              email={emailSearch}
              newClient={newClient}
              setSelectedContactGlobal={this.setSelectedContactGlobal}
              setSearchOnChange={this.setSearchOnChange}
              setSelectedSphereContact={this.setSelectedSphereContact}
              onFocus={this.onFocusEmail}
              onBlur={this.onBlurEmail}
              className="auto-complete-main"
              maxLength={FIELDS.max}
              extraClass={extraClass}
            />
          )}

          <p className="margin-bottom-2">
            <Translate value="fullName" />
          </p>
          <div className="form-group">
            <input
              type="text"
              className="form-control"
              disabled
              value={
                fullName
                || (lastName ? `${firstName} ${lastName}` : `${firstName}`)
              }
              onChange={e => this.setState({
                message: '',
                success: '',
                // fullName: e.target.value,
                firstName: e.target.value,
              })
              }
              maxLength={FIELDS.max}
            />
          </div>
          {listContracts.length > 0 && (
            <div className="form-group">
              <p style={{ marginBottom: '0px' }} className="margin-bottom-2">
                <Translate value="contract" />
              </p>
              <MultiSelect
                options={listContracts}
                checked={checked.filter(item => listContracts.find(
                  contractItem => contractItem.id === Number(item),
                ))}
                onSelectOptions={this.result}
                className="form-control multiSelect-input"
              />
            </div>
          )}

          <div
            className="justify-content-start display-flex"
            style={{ marginBottom: 10, gap: '1rem' }}
          >
            <div
              className="display-flex cursor-pointer"
              style={{ gap: '1rem' }}
            >
              <div>
                <p className="margin-bottom-2">
                  <Translate value="documentCompany" />
                </p>
                <img
                  src={documentCompany || 'images/default-image.jpg'}
                  className="img-logo-banners"
                  alt="Logo"
                  onClick={() => this.showImageModal(documentCompany, 'documentCompany')
                  }
                />
              </div>
            </div>

            <div className="cursor-pointer">
              <p className="margin-bottom-2">
                <Translate value="personalDocument" />
              </p>
              <img
                src={personalDocument || 'images/default-image.jpg'}
                className="img-logo-banners"
                alt="Logo"
                onClick={() => this.showImageModal(personalDocument, 'personalDocument')
                }
              />
            </div>
          </div>

          <h3>
            <Translate value="settings" />
          </h3>
          <div className="row margin-bottom-20" style={{ marginTop: 10 }}>
            <Checkbox
              onCheckBox={this.onCheckBox}
              permissions={permissions}
              config={config}
              inputsStateDisabled={inputsStateDisabled}
              inputsLabel={inputsLabel}
              translate
              companyTag={this.props.settings.companyTag}
              billetOff={this.props.settings.billetOff}
              opicName={this.props.opico}
            />
          </div>

          {this.props.settings.companyTag === 'chile' && (
            <div className="form-group">
              <p className="margin-bottom-2">
                <Translate value="clientWithdraw" />
              </p>
              <select
                onChange={e => this.selectedClientWithdraw('clientWithdraw', e)
                }
                className="custom-select"
                value={clientWithdraw == null ? -1 : Number(clientWithdraw)}
              >
                <option value="-1" />
                <option value="1">{I18n.t('yes')}</option>
                <option value="0">{I18n.t('no')}</option>
              </select>
            </div>
          )}

          {this.props.clients && !!listDeliveryLocations.length && (
            <div className="form-group">
              <p style={{ marginBottom: '0px' }} className="margin-bottom-2">
                {I18n.t('deliveryLocation')}
              </p>
              <MultiSelect
                options={listDeliveryLocations}
                checked={checkedDeliveryLocations}
                onSelectOptions={this.onSelectOptions}
                className="form-control multiSelect-input"
              />
            </div>
          )}

          <div className="form-group">
            <p className="margin-bottom-2">
              <Translate value="emailSeller" />
            </p>
            <textarea
              value={emailSeller}
              onChange={e => this.selectedItem('emailSeller', e)}
              className="form-control"
              placeholder={I18n.t('separateBySemicolon')}
              rows="3"
            />
          </div>

          {this.props.settings.companyTag === 'chile'
            && this.props.clients
            && this.getSelectComponent(
              I18n.t('place'),
              'locationId',
              locationId || '',
              this.getValuesLocation(this.props.clients.location),
              undefined,
              locationIdDisabled,
            )}

          {this.props.settings.companyTag === 'chile'
            && this.props.clients
            && this.getSelectComponent(
              I18n.t('bu'),
              'bu',
              bu || '',
              this.getValues(this.props.clients.bus),
              undefined,
              buDisabled,
            )}

          {this.props.settings.companyTag === 'chile' && listClient && (
            <div className="form-group">
              <p style={{ marginBottom: '0px' }} className="margin-bottom-2">
                <Translate value="deposit" />
              </p>
              <MultiSelect
                options={listClient}
                checked={checkedDepos}
                onSelectOptions={this.setDepos}
                className="form-control multiSelect-input"
                disabled={depositDisabled}
              />
            </div>
          )}

          <div>
            <p style={{ fontSize: 16 }}>
              <Translate value="approved1" />
            </p>
            {!newClient && approveId1 ? (
              <div className="form-group">
                <p className="margin-bottom-2">
                  <Translate value="email" />
                  <span
                    className="ml-2 change-input-link"
                    role="button"
                    tabIndex={0}
                    onKeyDown={this.resetApproveEmail1}
                    onClick={this.resetApproveEmail1}
                  >
                    (
                    <Translate value="change" />
                    )
                  </span>
                </p>
                <input
                  type="text"
                  className="form-control"
                  disabled
                  value={approveEmail1}
                />
              </div>
            ) : (
              <div>
                <ApproveInput
                  type="firstApproved"
                  permission={permissions.firstApproved}
                  onCheckBox={this.onCheckBox}
                  setApprover={this.setSelectedApprover}
                  clientId={clientId}
                  userId={userId}
                />
              </div>
            )}
          </div>
          <div>
            <p style={{ fontSize: 16 }}>
              <Translate value="approved2" />
            </p>
            {!newClient && approveId2 ? (
              <div className="form-group">
                <p className="margin-bottom-2">
                  <Translate value="email" />
                  <span
                    className="ml-2 change-input-link"
                    role="button"
                    tabIndex={0}
                    onKeyDown={this.resetApproveEmail2}
                    onClick={this.resetApproveEmail2}
                  >
                    (
                    <Translate value="change" />
                    )
                  </span>
                </p>
                <input
                  type="text"
                  className="form-control"
                  disabled
                  value={approveEmail2}
                />
              </div>
            ) : (
              <ApproveInput
                type="secondApproved"
                permission={permissions.secondApproved}
                onCheckBox={this.onCheckBox}
                setApprover={this.setSelectedApprover}
                clientId={clientId}
                userId={userId}
              />
            )}
          </div>

          {selectLimits && selectLimits.length > 0 && (
            <div className="form-group">
              <p className="margin-bottom-2">
                <Translate value="limitText" />
              </p>
              <select
                className="custom-select"
                value={!this.state.limit ? -1 : Number(this.state.limit)}
                required
                onChange={e => this.setUserLimit(e.target.value)}
              >
                {selectLimits.map((limit, index) => {
                  let limitText;
                  if (Number(limit.limit) >= 1) {
                    limitText = `${Number(index) + 1} - ${I18n.t(
                      'limitTo',
                    )}: ${NumberHelper.toCurrency(limit.limit)}`;
                  } else {
                    limitText = I18n.t('noLimit');
                  }
                  return (
                    <option
                      key={index}
                      value={limit.limit ? Number(limit.limit) : -1}
                    >
                      {limitText}
                    </option>
                  );
                })}
              </select>
            </div>
          )}

          <ButtonsUser
            newClient={newClient}
            goBack={this.goBack}
            createUserForm={registerSolicitation => this.createUserForm(registerSolicitation)
            }
            // createUser={this.createUser}
            updateUser={this.updateUser}
            location={this.props.back.location.state}
          />

          <p className="color-red margin-top-20">{message}</p>
          <p className="color-green margin-top-20">{success}</p>
          {showError && <Notification classe="danger" message={errorMessage} />}
        </form>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  solicitationUserClient: data => dispatch(solicitationUserClient(data)),
  solicitationApproveUser: (solicitationId, data) => dispatch(solicitationApproveUser(solicitationId, data)),
  updateUsers: (
    clientId,
    userId,
    data,
    approveId1,
    approveId2,
    locationId,
    bu,
    deposit,
    deliveryCode,
    clientWithdraw,
    emailSeller,
  ) => dispatch(
    updateUsersPermission(
      clientId,
      userId,
      data,
      approveId1,
      approveId2,
      locationId,
      bu,
      deposit,
      deliveryCode,
      clientWithdraw,
      emailSeller,
    ),
  ),

  createUser: user => dispatch(createUser(user)),
  downImage: image => dispatch(downloadImage(image)),

  searchSphereContacts: search => dispatch(searchSphereContacts(search)),
  getContracts: clientId => dispatch(getContracts(clientId)),
  getParamsNewUser: (clientId, state) => dispatch(getParamsNewUser(clientId, state)),
  searchItems: (limit, skip, clientId, search, type, status, order, field) => dispatch(
    getUsers(limit, skip, clientId, search, type, status, order, field),
  ),
  getClientSettings: nameAbbr => dispatch(ClientsAction.getClientSettings(nameAbbr)),
  updateStatusSolicitations: (solicitationId, solicitationStatus) => dispatch(updateStatusSolicitations(solicitationId, solicitationStatus)),
});

const mapStateToProps = state => ({
  clients: state.clients.clientsSettings,
  users: state.users.users,
  searched: state.users.searched,
  contracts: state.users.contracts,
  contractsFilter: state.users.contractsFilter,
  usersPermissionsDeleteApprovers: state.users.usersPermissionsDeleteApprovers,
  settings: state.settings,
  opico: state.settings.name,
});

export default connect(mapStateToProps, mapDispatchToProps)(UsersFormComponent);
